;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:locale/:path*?\",\"regex\":\"^/([^/]+)(?:/(.*))?$\",\"paramNames\":[\"locale\",\"path\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/editor\",\"regex\":\"^/([^/]+)/editor$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true}],\"staticRoutes\":[],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.1.6";import 'reflect-metadata';
import * as Sentry from '@sentry/nextjs';

// Browser-side Sentry initialization. The DSN is a public key (safe to inline into client JS);
// it is the SAME Sentry project as the server — server vs browser events are separated by Sentry
// automatically. Only enabled when NEXT_PUBLIC_SENTRY_DSN is present at build time.
if (process.env.NEXT_PUBLIC_SENTRY_DSN) {
    Sentry.init({
        dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
        environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT ?? 'local',
        release: process.env.NEXT_PUBLIC_SENTRY_RELEASE,
        sendDefaultPii: false,
        tracesSampleRate: 0,
    });
}

// Lets Sentry instrument App Router client-side navigations.
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
